import { Injectable, signal } from '@angular/core';

export type AppLang = 'fr' | 'en';

const LANG_KEY = 'ecl_vault_lang';

type TranslationMap = Record<string, string>;

const FR: TranslationMap = {
  'nav.public': 'Public',
  'nav.tournaments': 'Tournois',
  'nav.information': 'Information',
  'nav.hallOfFame': 'Hall of Fame',
  'nav.player': 'Joueur',
  'nav.profile': 'Mon profil',
  'nav.myMatches': 'Mes matchs',
  'nav.myTeams': 'Mes equipes',
  'nav.createTeam': 'Creer equipe',
  'nav.invitations': 'Invitations',
  'nav.backoffice': 'Back-office',
  'nav.boTournaments': 'Tournois BO',
  'nav.boRegistrations': 'Inscriptions BO',
  'nav.boScoreReports': 'Score reports BO',
  'topbar.login': 'Connexion',
  'topbar.register': 'Inscription',
  'topbar.playerLogout': 'Deconnexion joueur',
  'topbar.boLogout': 'Deconnexion BO',
  'topbar.doubleSession': 'Double session active (joueur + BO)',
  'identity.player': 'Joueur: {{value}}',
  'identity.bo': 'BO: {{email}} ({{role}})',
  'login.entry.title': 'Connexion',
  'login.entry.subtitle': 'Choisissez votre espace de connexion.',
  'login.entry.player.title': 'Joueur',
  'login.entry.player.desc': 'Acces au profil, equipes, inscriptions tournoi et score report.',
  'login.entry.player.cta': 'Connexion joueur',
  'login.entry.bo.title': 'Back-office',
  'login.entry.bo.desc': 'Acces BO pour le traitement des score reports selon votre role.',
  'login.entry.bo.cta': 'Connexion back-office',
  'player.login.title': 'Connexion joueur',
  'player.login.email': 'Email',
  'player.login.password': 'Mot de passe',
  'player.login.submit': 'Se connecter',
  'player.login.loading': 'Connexion...',
  'player.login.resend': 'Renvoyer l e-mail de verification',
  'player.login.resend.loading': 'Envoi en cours...',
  'player.login.noAccount': 'Pas de compte ? Inscription',
  'player.register.title': 'Inscription joueur',
  'player.register.hint': 'Le compte est cree en attente de verification email.',
  'player.register.email': 'Email',
  'player.register.pseudo': 'Pseudo',
  'player.register.activision': 'Activision ID',
  'player.register.password': 'Mot de passe',
  'player.register.passwordConfirm': 'Confirmation mot de passe',
  'player.register.submit': 'Creer le compte',
  'player.register.loading': 'Creation du compte...',
  'player.register.hasAccount': 'Deja un compte ? Connexion',
  'bo.login.title': 'Connexion back-office',
  'bo.login.email': 'Email BO',
  'bo.login.password': 'Mot de passe',
  'bo.login.submit': 'Se connecter',
  'bo.login.loading': 'Connexion en cours...',
  'bo.login.active': 'Session BO active.',
  'bo.login.openUi': 'Ouvrir UI6',
  'bo.tournaments.title': 'Back-office - Tournois',
  'bo.tournaments.subtitle': 'Generation manuelle du bracket pour les tournois eligibles.',
  'bo.tournaments.createTitle': 'Creer un tournoi (V1)',
  'bo.tournaments.createSubtitle': 'Creer un draft, puis publier quand il est pret.',
  'bo.tournaments.editTitle': 'Editer un tournoi draft',
  'bo.tournaments.editSubtitle': 'En BO V1, seuls les tournois en draft sont modifiables.',
  'bo.tournaments.loading': 'Chargement des tournois...',
  'bo.tournaments.loadError': 'Impossible de charger les tournois BO.',
  'bo.tournaments.emptyTitle': 'Aucun tournoi disponible.',
  'bo.tournaments.emptySubtitle': 'Creez ou publiez un tournoi cote back-office.',
  'bo.tournaments.noActiveTitle': 'Aucun tournoi actif dans la vue principale.',
  'bo.tournaments.noActiveSubtitle': 'Les tournois archives restent consultables dans la section dediee ci-dessous.',
  'bo.tournaments.status': 'Statut: {{value}}',
  'bo.tournaments.lifecycleStatus': 'Statut public: {{value}}',
  'bo.tournaments.registrationClose': 'Inscriptions fermees le: {{value}}',
  'bo.tournaments.eligibleTeams': 'Equipes validees: {{value}}',
  'bo.tournaments.estimatedRounds': 'Rounds estimes: {{value}}',
  'bo.tournaments.bracketCapacityValue': 'Capacite du bracket: {{value}}',
  'bo.tournaments.bracketTypeValue': 'Type de bracket prefere: {{value}}',
  'bo.tournaments.bracketStateValue': 'Etat du bracket: {{value}}',
  'bo.tournaments.archivedAt': 'Archive le: {{value}}',
  'bo.tournaments.finishedAt': 'Passe le: {{value}}',
  'bo.tournaments.bracketStateNone': 'Aucun',
  'bo.tournaments.bracketStateDraft': 'Draft',
  'bo.tournaments.bracketStatePublished': 'Publie',
  'bo.tournaments.lifecycle.upcoming': 'A venir',
  'bo.tournaments.lifecycle.ongoing': 'En cours',
  'bo.tournaments.lifecycle.past': 'Passe',
  'bo.tournaments.alreadyGenerated': 'Bracket deja genere.',
  'bo.tournaments.readOnlyRole': 'Consultation seule: votre role ne peut pas generer de bracket.',
  'bo.tournaments.notEligible': 'Tournoi non eligible a la generation pour le moment.',
  'bo.tournaments.finish': 'Passer en termine',
  'bo.tournaments.reopen': 'Reouvrir le tournoi',
  'bo.tournaments.finishing': 'Passage en termine...',
  'bo.tournaments.reopening': 'Reouverture...',
  'bo.tournaments.finishSuccess': 'Tournoi marque comme termine.',
  'bo.tournaments.reopenSuccess': 'Tournoi reouvert.',
  'bo.tournaments.finishError': "Impossible de marquer le tournoi comme termine.",
  'bo.tournaments.reopenError': "Impossible de reouvrir le tournoi.",
  'bo.tournaments.archive': 'Archiver',
  'bo.tournaments.unarchive': 'Desarchiver',
  'bo.tournaments.archiving': 'Archivage...',
  'bo.tournaments.unarchiving': 'Desarchivage...',
  'bo.tournaments.archiveSuccess': 'Tournoi archive avec succes.',
  'bo.tournaments.unarchiveSuccess': 'Tournoi desarchive avec succes.',
  'bo.tournaments.archiveError': "Impossible d'archiver le tournoi.",
  'bo.tournaments.unarchiveError': "Impossible de desarchiver le tournoi.",
  'bo.tournaments.archivedTitle': 'Tournois archives ({{count}})',
  'bo.tournaments.archivedSubtitle': 'Les tournois archives restent conserves et consultables sans encombrer la vue principale.',
  'bo.tournaments.showArchived': 'Afficher les archives',
  'bo.tournaments.hideArchived': 'Masquer les archives',
  'bo.tournaments.editDraft': 'Editer le draft',
  'bo.tournaments.openSetup': 'Configurer la generation',
  'bo.tournaments.manageDraftBracket': 'Gerer le draft bracket',
  'bo.tournaments.setupTitle': 'Generation bracket (V1)',
  'bo.tournaments.setupTitleDraft': 'Draft bracket (V1)',
  'bo.tournaments.bracketType': 'Type de bracket',
  'bo.tournaments.drawMode': 'Mode de tirage',
  'bo.tournaments.singleElimination': 'Single elimination',
  'bo.tournaments.doubleElimination': 'Double elimination',
  'bo.tournaments.drawModeRandom': 'Aleatoire',
  'bo.tournaments.drawModeSeeded': 'Seeded',
  'bo.tournaments.drawModeManual': 'Manuel',
  'bo.tournaments.drawModeWheel': 'Wheel',
  'bo.tournaments.rulePublished': 'Tournoi publie',
  'bo.tournaments.ruleRegistrationClosed': 'Inscriptions closes',
  'bo.tournaments.ruleMinimumTeams': 'Minimum 2 equipes validees',
  'bo.tournaments.ruleCapacityCompatible': 'Le nombre d equipes validees reste compatible avec la capacite cible',
  'bo.tournaments.ruleNoPublishedBracket': 'Aucun bracket publie ne bloque ce tournoi',
  'bo.tournaments.ruleSeedingReady': 'Les seeds forment un ensemble valide de 1 a N pour les equipes validees',
  'bo.tournaments.ruleManualReady': 'Chaque equipe validee a un slot manuel unique compris entre 1 et la capacite cible',
  'bo.tournaments.ruleWheelReady': 'Les ordres wheel forment un ensemble valide de 1 a N pour les equipes validees',
  'bo.tournaments.ruleDraftMatchesCurrentTeams': 'Le draft correspond encore au draw actuel (equipes + seeds, ordre wheel ou slots manuels)',
  'bo.tournaments.generateDraft': 'Generer le draft bracket',
  'bo.tournaments.regenerateDraft': 'Regenerer le draft bracket',
  'bo.tournaments.publishBracket': 'Publier le bracket',
  'bo.tournaments.publishingBracket': 'Publication du bracket...',
  'bo.tournaments.generating': 'Generation...',
  'bo.tournaments.cancelSetup': 'Annuler',
  'bo.tournaments.success': 'Bracket draft mis a jour avec succes.',
  'bo.tournaments.publishBracketSuccess': 'Bracket publie avec succes.',
  'bo.tournaments.generateError': 'Generation impossible.',
  'bo.tournaments.publishBracketError': 'Publication du bracket impossible.',
  'bo.tournaments.publishBracketNotReady': "Le draft bracket n'est pas encore publiable.",
  'bo.tournaments.publishBlockedRegistrationOpen': 'La publication du bracket attend la cloture des inscriptions.',
  'bo.tournaments.publishBlockedDraftChanged': 'Le draft ne correspond plus au draw actuel (equipes ou seeds). Regenerez avant de publier.',
  'bo.tournaments.publishBlockedSeedsChanged': 'Les seeds actuelles ne correspondent plus au draft. Regenerez avant de publier.',
  'bo.tournaments.publishBlockedManualChanged': 'Les slots manuels actuels ne correspondent plus au draft. Regenerez avant de publier.',
  'bo.tournaments.publishBlockedWheelChanged': "L'ordre wheel actuel ne correspond plus au draft. Regenerez avant de publier.",
  'bo.tournaments.publishBlockedMinimumTeams': 'Au moins 2 equipes validees sont necessaires avant de publier le bracket.',
  'bo.tournaments.publishBlockedCapacityExceeded': 'Le nombre d equipes validees depasse la capacite cible du bracket.',
  'bo.tournaments.noDraftBracket': 'Aucun draft bracket disponible.',
  'bo.tournaments.viewRegistrations': 'Voir les inscriptions',
  'bo.tournaments.previewBracket': 'Voir le bracket BO',
  'bo.tournaments.saveDraft': 'Enregistrer le draft',
  'bo.tournaments.publishNow': 'Publier maintenant',
  'bo.tournaments.saving': 'Enregistrement...',
  'bo.tournaments.publishing': 'Publication...',
  'bo.tournaments.cancelEdit': "Annuler l'edition",
  'bo.tournaments.draftCreatedSuccess': 'Tournoi draft cree.',
  'bo.tournaments.draftUpdatedSuccess': 'Tournoi draft mis a jour.',
  'bo.tournaments.publishedSuccess': 'Tournoi publie avec succes.',
  'bo.tournaments.saveError': "Impossible d'enregistrer le tournoi.",
  'bo.tournaments.publishError': 'Impossible de publier le tournoi.',
  'bo.tournaments.form.name': 'Nom',
  'bo.tournaments.form.slug': 'Slug',
  'bo.tournaments.form.game': 'Jeu',
  'bo.tournaments.form.tournamentType': 'Type de tournoi',
  'bo.tournaments.form.teamTournament': 'Equipe',
  'bo.tournaments.form.individualTournament': 'Individuel',
  'bo.tournaments.form.formatLabel': 'Label format',
  'bo.tournaments.form.region': 'Region',
  'bo.tournaments.form.startsAt': 'Commence le',
  'bo.tournaments.form.registrationClosesAt': 'Cloture des inscriptions',
  'bo.tournaments.form.checkInOpensAt': 'Ouverture du check-in',
  'bo.tournaments.form.checkInClosesAt': 'Fermeture du check-in',
  'bo.tournaments.form.bracketCapacity': 'Capacite du bracket',
  'bo.tournaments.form.bracketType': 'Type de bracket',
  'bo.tournaments.form.crossplay': 'Crossplay active',
  'bo.tournaments.form.description': 'Description',
  'bo.tournaments.form.rules': 'Regles',
  'bo.tournaments.form.prizePool': 'Prize pool',
  'bo.tournaments.form.bannerUrl': 'URL de la banniere',
  'bo.tournaments.toReports': 'Aller vers Score reports BO',
  'bo.registrations.title': 'Back-office - Inscriptions tournoi',
  'bo.registrations.back': '<- Retour aux tournois BO',
  'bo.registrations.tournament': 'Tournoi',
  'bo.registrations.selectTournament': 'Choisir un tournoi',
  'bo.registrations.load': 'Charger',
  'bo.registrations.session': 'Session back-office',
  'bo.registrations.tournamentsLoading': 'Chargement des tournois...',
  'bo.registrations.loading': 'Chargement des inscriptions...',
  'bo.registrations.emptyTitle': 'Aucune inscription pour ce tournoi.',
  'bo.registrations.emptySubtitle': 'Les equipes validees apparaitront ici pour traitement BO.',
  'bo.registrations.forbiddenTournaments': 'Votre role ne peut pas consulter la liste des tournois BO.',
  'bo.registrations.loadTournamentsError': 'Impossible de charger les tournois BO.',
  'bo.registrations.forbiddenList': 'Votre role ne peut pas consulter ces inscriptions.',
  'bo.registrations.loadError': 'Impossible de charger les inscriptions.',
  'bo.registrations.submittedAt': 'Soumis le: {{value}}',
  'bo.registrations.checkedInAt': 'Check-in effectue le: {{value}}',
  'bo.registrations.latestDecision': 'Derniere decision: {{value}} ({{date}})',
  'bo.registrations.seed': 'Seed BO',
  'bo.registrations.wheelTitle': 'Wheel BO',
  'bo.registrations.wheelSubtitle': 'Genere un ordre persiste pour les equipes validees, reutilisable par le draw mode wheel.',
  'bo.registrations.wheelRun': 'Lancer la wheel',
  'bo.registrations.wheelRunning': 'Wheel en cours...',
  'bo.registrations.wheelOrderValue': 'Ordre wheel BO: {{value}}',
  'bo.registrations.seedSave': 'Enregistrer le seed',
  'bo.registrations.seedSaving': 'Enregistrement du seed...',
  'bo.registrations.saved': 'Enregistre',
  'bo.registrations.manualSlot': 'Slot manuel BO',
  'bo.registrations.manualSlotSave': 'Enregistrer le slot',
  'bo.registrations.manualSlotSaving': 'Enregistrement du slot...',
  'bo.registrations.reason': 'Raison BO (optionnelle)',
  'bo.registrations.saving': 'Enregistrement...',
  'bo.registrations.decisionError': "Impossible d'appliquer la decision.",
  'bo.registrations.seedError': "Impossible d'enregistrer le seed.",
  'bo.registrations.wheelError': "Impossible de lancer la wheel.",
  'bo.registrations.manualSlotError': "Impossible d'enregistrer le slot manuel.",
  'bo.registrations.checkIn': 'Check-in BO',
  'bo.registrations.checkInLoading': 'Check-in...',
  'bo.registrations.checkInError': "Impossible d'effectuer le check-in.",
  'bo.registrations.status.submitted': 'Submitted',
  'bo.registrations.status.toFix': 'Changes requested',
  'bo.registrations.status.validated': 'Validated',
  'bo.registrations.status.validatedConditionally': 'Conditionally approved',
  'bo.registrations.status.rejected': 'Rejected',
  'bo.registrations.status.cancelled': 'Cancelled',
  'bo.registrations.action.toFix': 'Demander des corrections',
  'bo.registrations.action.validate': 'Valider',
  'bo.registrations.action.validateConditionally': 'Approuver sous conditions',
  'bo.registrations.action.reject': 'Rejeter',
  'bo.registrations.action.cancel': 'Annuler',
  'bo.registrations.checkIn.checkedIn': 'Equipe deja check-in.',
  'bo.registrations.checkIn.eligible': 'Equipe eligible au check-in BO.',
  'bo.registrations.checkIn.closed': 'Fenetre de check-in fermee.',
  'bo.registrations.checkIn.notEligible': 'Equipe non eligible au check-in.',
  'public.list.title': 'Tournois publics',
  'public.list.subtitle': 'Regroupes en blocs pour une lecture plus claire.',
  'public.list.visibleCount': '{{count}} tournoi(s) visible(s)',
  'public.list.loading': 'Chargement...',
  'public.list.error': 'Impossible de charger les tournois.',
  'public.list.empty': 'Aucun tournoi publie pour le moment.',
  'public.list.activeBlock': 'A venir / en cours',
  'public.list.activeHint': 'Classement pilote par le statut public expose par le backend.',
  'public.list.activeEmpty': 'Aucun tournoi a venir ou en cours.',
  'public.list.pastBlock': 'Tournois passes',
  'public.list.pastHint': 'Tournois classes comme termines par la source de verite backend.',
  'public.list.pastEmpty': 'Aucun tournoi passe pour le moment.',
  'public.list.inProgress': 'En cours',
  'public.list.region': 'Region: {{value}}',
  'public.list.start': 'Debut: {{value}}',
  'public.list.viewDetail': 'Voir le detail du tournoi',
  'public.detail.back': '<- Retour a la liste',
  'public.detail.region': 'Region: {{value}}',
  'public.detail.crossplay.on': 'Crossplay actif',
  'public.detail.crossplay.off': 'Sans crossplay',
  'public.detail.viewBracket': 'Voir le bracket',
  'public.detail.registerTeam': 'Inscrire une equipe',
  'public.detail.loginNeeded': 'Connectez-vous avec un compte joueur pour inscrire une equipe.',
  'public.detail.goLogin': 'Se connecter pour s inscrire',
  'public.detail.start': 'Debut:',
  'public.detail.registrationClose': 'Cloture inscriptions:',
  'public.detail.prize': 'Dotation:',
  'public.detail.description': 'Description',
  'public.detail.rules': 'Regles',
  'public.detail.loading': 'Chargement...',
  'public.detail.error': 'Impossible de charger ce tournoi.',
  'public.bracket.back': '<- Retour au tournoi',
  'public.bracket.backToMatches': '<- Retour a mes matchs',
  'public.bracket.titleSuffix': 'Bracket',
  'public.bracket.readOnly': 'Lecture seule: les resultats officiels sont valides cote back-office.',
  'bo.bracketPreview.back': '<- Retour aux tournois BO',
  'bo.bracketPreview.eyebrow': 'Bracket BO',
  'bo.bracketPreview.draftLegend': 'Preview BO uniquement: ce draft bracket nest pas encore visible publiquement.',
  'bo.bracketPreview.publishedLegend': 'Preview BO: ce bracket est deja publie et visible cote public.',
  'bo.bracketPreview.loading': 'Chargement du bracket BO...',
  'bo.bracketPreview.error': 'Bracket BO indisponible pour ce tournoi.',
  'public.bracket.loading': 'Chargement du bracket...',
  'public.bracket.error': 'Bracket indisponible pour ce tournoi.',
  'public.bracket.match': 'Match {{value}}',
  'public.bracket.tbd': 'A definir',
  'public.bracket.winner': 'Vainqueur:',
  'public.bracket.reportScore': 'Reporter score',
  'public.bracket.contestReport': 'Contester report',
  'public.bracket.kind.simple': 'Elimination simple',
  'player.profile.title': 'Mon profil joueur',
  'player.profile.subtitle': 'Espace prive: vos informations de compte et d identite de jeu.',
  'player.profile.loading': 'Chargement...',
  'player.profile.emailReadonly': 'Email (non modifiable)',
  'player.profile.pseudo': 'Pseudo',
  'player.profile.activision': 'Activision ID',
  'player.profile.avatar': 'Avatar URL (optionnel)',
  'player.profile.country': 'Pays ISO 2 lettres (optionnel)',
  'player.profile.save': 'Enregistrer les modifications',
  'player.profile.saving': 'Sauvegarde...',
  'player.profile.updated': 'Profil mis a jour.',
  'player.profile.loadError': 'Impossible de charger le profil.',
  'player.profile.updateError': 'Mise a jour impossible.',
  'player.matches.title': 'Mes matchs a reporter',
  'player.matches.subtitle': 'Inbox d actions minimale: seulement les matchs que vous pouvez reporter maintenant.',
  'player.matches.openTournaments': 'Voir les tournois',
  'player.matches.loading': 'Chargement de vos matchs reportables...',
  'player.matches.emptyTitle': 'Aucun match a reporter pour le moment.',
  'player.matches.emptySubtitle': 'Revenez plus tard ou consultez les brackets publics pour suivre vos rencontres.',
  'player.matches.emptyCta': 'Voir les tournois',
  'player.matches.loadError': 'Impossible de charger vos matchs reportables.',
  'player.matches.matchNumber': 'Match {{value}}',
  'player.matches.startsAt': 'Debut tournoi: {{value}}',
  'player.matches.viewBracket': 'Voir le bracket',
  'player.matches.reportScore': 'Reporter score',
  'player.matches.status.ready': 'Pret a reporter',
  'player.matches.status.reported': 'Reporte',
  'player.matches.status.inReview': 'En revue BO',
  'player.matches.status.rejected': 'A corriger',
  'player.teams.title': 'Mes equipes',
  'player.teams.create': 'Creer une equipe',
  'player.teams.loading': 'Chargement de vos equipes...',
  'player.teams.none.title': 'Vous n avez encore aucune equipe.',
  'player.teams.none.subtitle': 'Creez votre equipe ou acceptez un lien d invitation recu.',
  'player.teams.myRole': 'Mon role: {{value}}',
  'player.teams.logo': 'Logo: {{value}}',
  'player.teams.viewRoster': 'Voir le roster',
  'player.teams.openTournaments': 'Voir les tournois',
  'player.teams.manageable': 'Equipe gerable pour inscription tournoi',
  'player.teams.notManageable': 'Equipe non gerable (membre simple)',
  'player.teams.loadError': 'Impossible de charger vos equipes. Reessayez.',
  'player.teamCreate.title': 'Creer une equipe',
  'player.teamCreate.subtitle': 'A la creation, vous devenez captain de cette equipe.',
  'player.teamCreate.name': 'Nom equipe',
  'player.teamCreate.logo': 'Logo URL (optionnel)',
  'player.teamCreate.submit': 'Creer l equipe',
  'player.teamCreate.loading': 'Creation de l equipe...',
  'player.teamCreate.links': 'Voir mes equipes · Voir mes invitations',
  'player.teamCreate.viewTeams': 'Voir mes equipes',
  'player.teamCreate.viewInvitations': 'Voir mes invitations',
  'player.teamCreate.error': 'Creation de l equipe impossible. Verifiez les champs puis reessayez.',
  'player.teamDetail.back': '<- Retour a mes equipes',
  'player.teamDetail.loading': 'Chargement equipe...',
  'player.teamDetail.myRole': 'Mon role:',
  'player.teamDetail.logo': 'Logo: {{value}}',
  'player.teamDetail.inviteTitle': 'Invitation par lien',
  'player.teamDetail.inviteSubtitle': 'Generez ou regenerer un lien partageable pour inviter un joueur a rejoindre l equipe.',
  'player.teamDetail.inviteGenerate': 'Generer un lien d invitation',
  'player.teamDetail.inviteRegenerate': 'Regenerer le lien',
  'player.teamDetail.generating': 'Generation...',
  'player.teamDetail.inviteReady': 'Lien disponible. Vous pouvez maintenant le partager.',
  'player.teamDetail.inviteError': 'Impossible de generer le lien d invitation.',
  'player.teamDetail.rosterTitle': 'Roster',
  'player.teamDetail.tournamentHubTitle': 'Parcours tournoi',
  'player.teamDetail.tournamentHubManageable': 'Vous pouvez inscrire cette equipe sur un tournoi ouvert.',
  'player.teamDetail.tournamentHubNotManageable': 'Vous pouvez consulter les tournois, mais l inscription est reservee au captain/manager_equipe.',
  'player.teamDetail.tournamentHubCta': 'Parcourir les tournois',
  'player.teamDetail.remove': 'Retirer',
  'player.teamDetail.removing': 'Retrait...',
  'player.teamDetail.removed': 'Membre retire de l equipe.',
  'player.teamDetail.removeError': 'Retrait impossible.',
  'player.teamDetail.role.captain': 'Captain',
  'player.teamDetail.role.manager': 'Manager equipe',
  'player.teamDetail.role.player': 'Joueur',
  'player.teamDetail.forbidden': 'Acces refuse: vous devez etre membre de cette equipe.',
  'player.teamDetail.loadError': 'Impossible de charger cette equipe.',
  'player.invitations.title': 'Mes invitations d equipe',
  'player.invitations.loading': 'Chargement des invitations...',
  'player.invitations.none.title': 'Aucune invitation en attente.',
  'player.invitations.none.subtitle': 'Vous pouvez consulter vos equipes, en creer une, ou revenir aux tournois publics.',
  'player.invitations.from': 'Invite par: {{value}}',
  'player.invitations.role': 'Role propose: {{value}}',
  'player.invitations.date': 'Date: {{value}}',
  'player.invitations.accept': 'Accepter l invitation',
  'player.invitations.accepting': 'Acceptation en cours...',
  'player.invitations.acceptError': 'Impossible d accepter cette invitation pour le moment.',
  'player.invitations.loadError': 'Impossible de charger les invitations. Reessayez.',
  'teamInvite.title': 'Invitation d equipe',
  'teamInvite.loading': 'Chargement du lien d invitation...',
  'teamInvite.role': 'Role propose: {{value}}',
  'teamInvite.expires': 'Expire le: {{value}}',
  'teamInvite.authRequired': 'Connectez-vous ou creez votre compte pour accepter cette invitation.',
  'teamInvite.playerLogin': 'Connexion joueur',
  'teamInvite.playerRegister': 'Inscription joueur',
  'teamInvite.accept': 'Rejoindre cette equipe',
  'teamInvite.accepting': 'Acceptation...',
  'teamInvite.accepted': 'Invitation acceptee. Redirection vers votre equipe...',
  'teamInvite.invalid': 'Lien d invitation invalide.',
  'teamInvite.loadError': 'Impossible de charger ce lien d invitation.',
  'teamInvite.error': 'Impossible d accepter ce lien pour le moment.',
  'teamInvite.reason.expired': 'Ce lien d invitation a expire.',
  'teamInvite.reason.alreadyMember': 'Vous etes deja membre de cette equipe.',
  'teamInvite.reason.consumed': 'Cette invitation a deja ete consommee.',
  'teamInvite.reason.full': 'Cette equipe est complete (max 6 joueurs).',
  'teamInvite.reason.playerRequired': 'Seul un compte joueur actif peut accepter cette invitation.',
  'teamInvite.reason.unavailable': 'Cette invitation n est plus disponible.',
  'reg.back': '<- Retour au tournoi',
  'reg.title': 'Inscription au tournoi (equipe)',
  'reg.subtitle': 'Seules vos equipes gerables (capitaine/manager_equipe) peuvent etre inscrites.',
  'reg.pageLoading': 'Chargement du tournoi...',
  'reg.start': 'Debut: {{value}}',
  'reg.close': 'Cloture inscriptions: {{value}}',
  'reg.actionTitle': 'Action d inscription',
  'reg.actionStateTitle': 'Etat actuel',
  'reg.actionState.closed': 'Inscriptions fermees',
  'reg.actionState.already': 'Inscription deja active',
  'reg.actionState.noTeam': 'Aucune equipe gerable',
  'reg.actionState.ready': 'Inscription possible',
  'reg.actionReasonTitle': 'Raison',
  'reg.nextStepTitle': 'Prochaine etape',
  'reg.nextStep.closed': 'Consulter le bracket ou les resultats du tournoi.',
  'reg.nextStep.already': 'Verifier le statut de votre inscription ci-dessous puis faire le check-in si eligible.',
  'reg.nextStep.noTeam': 'Creer une equipe ou obtenir un role captain/manager_equipe.',
  'reg.nextStep.ready': 'Selectionnez une equipe puis validez l inscription.',
  'reg.closed': 'Les inscriptions sont fermees pour ce tournoi.',
  'reg.already': 'Une inscription existe deja pour {{team}} (statut: {{status}}).',
  'reg.noNeed': 'Aucune nouvelle inscription n est necessaire pour le moment.',
  'reg.teamsLoading': 'Chargement des equipes...',
  'reg.noManageable': 'Vous n avez pas encore d equipe gerable pour inscrire un roster.',
  'reg.nextAction': 'Prochaine action:',
  'reg.createTeamLink': 'creer une equipe',
  'reg.teamLabel': 'Equipe',
  'reg.teamSelect': '-- Selectionner une equipe --',
  'reg.submit': 'Inscrire l equipe',
  'reg.submitting': 'Inscription en cours...',
  'reg.listTitle': 'Mes inscriptions sur ce tournoi',
  'reg.listLoading': 'Chargement des inscriptions...',
  'reg.listEmpty': 'Aucune inscription pour ce tournoi.',
  'reg.status': 'statut: {{value}}',
  'reg.submittedAt': 'Soumis le: {{value}}',
  'reg.cancelledAt': 'Annule le: {{value}}',
  'reg.checkIn.ok': 'Check-in valide pour cette equipe.',
  'reg.checkIn.eligible': 'Equipe eligible au check-in.',
  'reg.checkIn.closed': 'Check-in non disponible: fenetre fermee.',
  'reg.checkIn.notEligible': 'Check-in non eligible (statut actuel: {{value}}).',
  'reg.checkIn.do': 'Faire le check-in',
  'reg.checkIn.loading': 'Check-in en cours...',
  'reg.cancel': 'Annuler l inscription',
  'reg.cancel.loading': 'Annulation en cours...',
  'reg.loadError': 'Impossible de charger ce tournoi.',
  'reg.selectTeam': 'Selectionnez une equipe.',
  'reg.successRegistered': 'Inscription enregistree pour {{team}} ({{status}}).',
  'reg.error': 'Inscription impossible.',
  'reg.successCancelled': 'Inscription annulee pour {{team}}.',
  'reg.cancelError': 'Annulation impossible.',
  'reg.successCheckIn': 'Check-in confirme pour {{team}}.',
  'reg.checkInError': 'Check-in impossible.',
  'reg.listError': 'Impossible de charger vos inscriptions sur ce tournoi.',
  'reg.quickLinks': 'Liens rapides',
  'reg.quick.toTeams': 'Mes equipes',
  'reg.quick.toBracket': 'Bracket du tournoi',
  'reg.quick.toTournament': 'Detail du tournoi',
  'reg.status.submitted': 'soumise',
  'reg.status.to_fix': 'a corriger',
  'reg.status.validated': 'validee',
  'reg.status.validated_conditionally': 'validee sous condition',
  'reg.status.rejected': 'rejetee',
  'reg.status.cancelled': 'annulee',
  'score.back': '<- Retour au bracket',
  'score.backToMatches': '<- Retour a mes matchs',
  'score.title': 'Score report joueur',
  'score.hint': 'Tournoi: {{slug}} - Match: {{id}}',
  'score.hint2': 'Equipe reporting proposee automatiquement parmi vos equipes presentes dans ce match.',
  'score.loading': 'Chargement du score report...',
  'score.status': 'Statut:',
  'score.editable': 'Modifiable:',
  'score.yes': 'Oui',
  'score.no': 'Non',
  'score.reportingTeam': 'Equipe reporting:',
  'score.global': 'Score global:',
  'score.updated': 'Maj:',
  'score.none': 'Aucun score report pour ce match.',
  'score.form.edit': 'Modifier report',
  'score.form.new': 'Nouveau report',
  'score.form.team': 'Equipe reporting',
  'score.form.selectTeam': '-- Selectionner equipe --',
  'score.form.noTeam': 'Aucune equipe eligible trouvee pour ce match.',
  'score.form.team1': 'Score team 1',
  'score.form.team2': 'Score team 2',
  'score.form.teamNamed': 'Score {{team}}',
  'score.form.note': 'Note (optionnel)',
  'score.games.title': 'Detail maps/games (optionnel)',
  'score.games.add': 'Ajouter map/game',
  'score.games.num': 'Partie #',
  'score.games.map': 'Carte',
  'score.games.t1': 'E1',
  'score.games.t2': 'E2',
  'score.shots.title': 'Screenshot de preuve',
  'score.shots.add': 'Ajouter screenshot URL',
  'score.shots.file': 'Proof screenshot',
  'score.shots.help': '1 image max. Accepted: PNG, JPG/JPEG, WEBP. Max 5 MB.',
  'score.shots.none': 'No proof screenshot attached.',
  'score.shots.current': 'Current proof',
  'score.shots.selected': 'Selected proof',
  'score.shots.invalidType': 'Only PNG, JPG/JPEG, or WEBP images are allowed.',
  'score.shots.tooLarge': 'Image must be 5 MB or smaller.',
  'score.shots.previewAlt': 'Score proof screenshot preview',
  'score.shots.position': 'Position',
  'score.shots.url': 'URL screenshot',
  'score.shots.caption': 'Legende',
  'score.remove': 'Suppr',
  'score.submit': 'Soumettre le score report',
  'score.submitting': 'Soumission en cours...',
  'score.locked': 'Report non modifiable depuis l espace joueur (statut final).',
  'score.selectTeamError': 'Selectionnez une equipe reporting.',
  'score.saved': 'Score report enregistre.',
  'score.saveError': 'Enregistrement impossible.',
  'score.contest.title': 'Contester ce report',
  'score.contest.edit': 'Mettre a jour la contestation',
  'score.contest.help': 'Utilisez ce formulaire si l equipe adverse a signale un score que vous contestez.',
  'score.contest.team': 'Equipe contestante',
  'score.contest.note': 'Message de contestation',
  'score.contest.submit': 'Envoyer la contestation',
  'score.contest.update': 'Mettre a jour la contestation',
  'score.contest.submitting': 'Envoi en cours...',
  'score.contest.saved': 'Contestation enregistree.',
  'score.contest.saveError': 'Contestation impossible.',
  'score.contest.error': 'Selectionnez une equipe et ajoutez un message de contestation.',
  'score.contest.locked': 'Ce report ne peut plus etre conteste.',
  'score.contest.ownTeam': 'L equipe reporting ne peut pas contester son propre report.',
  'score.contest.banner': 'Report conteste',
  'score.contest.teamBanner': 'Equipe contestante: {{team}}',
  'score.contest.noteBanner': 'Message: {{value}}',
  'score.loadError': 'Impossible de charger le score report.',
  'score.status.reported': 'Reported (en attente BO)',
  'score.status.review': 'In review (en revue BO)',
  'score.status.validated': 'Validated (officiel)',
  'score.status.rejected': 'Rejected (a corriger)',
  'bo.reports.title': 'Back-office - Rapports de score',
  'bo.reports.tournament': 'Tournoi',
  'bo.reports.selectTournament': '-- Selectionner tournoi --',
  'bo.reports.load': 'Charger',
  'bo.reports.session': 'Session back-office',
  'bo.reports.tournamentsLoading': 'Chargement des tournois...',
  'bo.reports.loading': 'Chargement des rapports...',
  'bo.reports.emptyTitle': 'Aucun rapport de score pour ce tournoi.',
  'bo.reports.emptySubtitle': 'Verifier qu au moins un match a ete reporte par une equipe.',
  'bo.reports.report': 'Rapport #{{id}}',
  'bo.reports.match': 'Match: {{match}} | Equipe: {{team}}',
  'bo.reports.score': 'Score: {{s1}} - {{s2}} | Date: {{date}}',
  'bo.reports.detail': 'Voir le detail',
  'bo.reports.loadTournamentsError': 'Impossible de charger la liste des tournois BO.',
  'bo.reports.loadError': 'Impossible de charger les score reports BO.',
  'bo.reports.forbiddenList': 'Acces refuse: vous pouvez consulter les reports mais pas traiter ce tournoi.',
  'bo.reports.forbiddenTournaments': 'Acces refuse: votre role back-office n autorise pas cette consultation.',
  'bo.reports.status.reported': 'Reporte',
  'bo.reports.status.review': 'En revue',
  'bo.reports.status.validated': 'Valide',
  'bo.reports.status.rejected': 'Rejete',
  'bo.reports.contested': 'Conteste',
  'bo.reportDetail.back': '<- Retour liste',
  'bo.reportDetail.title': 'BO - Detail score report',
  'bo.reportDetail.loading': 'Chargement...',
  'bo.reportDetail.report': 'Report #{{id}}',
  'bo.reportDetail.status': 'statut: {{value}}',
  'bo.reportDetail.match': 'Match: {{id}} (R{{round}} M{{match}})',
  'bo.reportDetail.team': 'Equipe reporting: {{team}} | User: {{user}}',
  'bo.reportDetail.global': 'Score global: {{s1}} - {{s2}}',
  'bo.reportDetail.date': 'Date report: {{date}}',
  'bo.reportDetail.note': 'Note: {{value}}',
  'bo.reportDetail.games': 'Detail maps/games',
  'bo.reportDetail.noGames': 'Aucun detail map/game.',
  'bo.reportDetail.gameRow': 'Partie {{num}} - {{map}} - {{s1}}:{{s2}}',
  'bo.reportDetail.screens': 'Screenshots URL',
  'bo.reportDetail.noScreens': 'Aucun screenshot.',
  'bo.reportDetail.openPreview': 'Ouvrir preview',
  'bo.reportDetail.previewTitle': 'Preview screenshot',
  'bo.reportDetail.closePreview': 'Fermer',
  'bo.reportDetail.contestTitle': 'Contestation adverse',
  'bo.reportDetail.contestTeam': 'Equipe contestante: {{team}}',
  'bo.reportDetail.contestUser': 'Joueur: {{user}}',
  'bo.reportDetail.contestDate': 'Date contestation: {{date}}',
  'bo.reportDetail.contestNote': 'Message: {{value}}',
  'bo.reportDetail.decision': 'Decision admin',
  'bo.reportDetail.newStatus': 'Nouveau statut',
  'bo.reportDetail.optNote': 'Note (optionnel)',
  'bo.reportDetail.apply': 'Appliquer decision',
  'bo.reportDetail.applied': 'Decision appliquee: {{value}}',
  'bo.reportDetail.history': 'Historique decisions',
  'bo.reportDetail.noHistory': 'Aucune decision enregistree.',
  'bo.reportDetail.historyRow': '{{from}} -> {{to}} | acteur {{actor}} | {{date}}',
  'bo.reportDetail.historyNote': ' | note: {{value}}',
  'bo.reportDetail.forbiddenOpen': 'Acces refuse: votre role ne permet pas d ouvrir ce score report.',
  'bo.reportDetail.loadError': 'Chargement detail impossible.',
  'bo.reportDetail.forbiddenApply': 'Acces refuse: vous n avez pas le droit d appliquer cette decision.',
  'bo.reportDetail.decisionError': 'Decision impossible.',
  'information.title': 'Information',
  'information.subtitle': 'Presentation publique de la ligue ECL Vault.',
  'information.vision': 'Notre vision',
  'information.visionText': 'ECL Vault propose une plateforme de competition esports orientee lisibilite des tournois, integrite des resultats et experience communautaire.',
  'information.structured': 'Tournois structures',
  'information.structuredText': 'Calendrier public, brackets consultables, progression des rounds transparente.',
  'information.verified': 'Resultats verifies',
  'information.verifiedText': 'Signalement equipe, revue back-office et validation officielle avant propagation.',
  'information.playerExp': 'Experience joueur',
  'information.playerExpText': 'Comptes, equipes, inscriptions, check-in et suivi des matchs dans un flow unique.',
  'information.note': 'Note produit',
  'information.noteText': 'Cette page est un placeholder public credible en attente de contenu editorial final valide par l equipe produit.',
  'hof.title': 'Hall of Fame',
  'hof.subtitle': 'Classements visuels provisoires en attente des donnees officielles automatisees.',
  'hof.mock': 'Mock',
  'hof.feed': 'Public feed',
  'hof.topTeams': 'Top Teams',
  'hof.topPlayers': 'Top Players',
  'hof.recentWinners': 'Recent Winners',
  'hof.col.rank': '#',
  'hof.col.team': 'Equipe',
  'hof.col.points': 'Points',
  'hof.col.titles': 'Titres',
  'hof.col.player': 'Joueur',
  'hof.col.rating': 'Rating',
  'hof.note': 'Donnees Hall of Fame provisoires: structure visuelle cible sans logique de classement branchee au backend.'
};

const EN: TranslationMap = {
  'nav.public': 'Public',
  'nav.tournaments': 'Tournaments',
  'nav.information': 'Information',
  'nav.hallOfFame': 'Hall of Fame',
  'nav.player': 'Player',
  'nav.profile': 'My profile',
  'nav.myMatches': 'My matches',
  'nav.myTeams': 'My teams',
  'nav.createTeam': 'Create team',
  'nav.invitations': 'Invitations',
  'nav.backoffice': 'Back-office',
  'nav.boTournaments': 'BO tournaments',
  'nav.boRegistrations': 'BO registrations',
  'nav.boScoreReports': 'BO score reports',
  'topbar.login': 'Login',
  'topbar.register': 'Register',
  'topbar.playerLogout': 'Player logout',
  'topbar.boLogout': 'BO logout',
  'topbar.doubleSession': 'Dual session active (player + BO)',
  'identity.player': 'Player: {{value}}',
  'identity.bo': 'BO: {{email}} ({{role}})',
  'login.entry.title': 'Login',
  'login.entry.subtitle': 'Choose your login space.',
  'login.entry.player.title': 'Player',
  'login.entry.player.desc': 'Access profile, teams, tournament registrations and score reports.',
  'login.entry.player.cta': 'Player login',
  'login.entry.bo.title': 'Back-office',
  'login.entry.bo.desc': 'BO access for score report processing according to your role.',
  'login.entry.bo.cta': 'Back-office login',
  'player.login.title': 'Player login',
  'player.login.email': 'Email',
  'player.login.password': 'Password',
  'player.login.submit': 'Sign in',
  'player.login.loading': 'Signing in...',
  'player.login.resend': 'Resend verification email',
  'player.login.resend.loading': 'Sending...',
  'player.login.noAccount': 'No account yet? Register',
  'player.register.title': 'Player registration',
  'player.register.hint': 'The account is created pending email verification.',
  'player.register.email': 'Email',
  'player.register.pseudo': 'Nickname',
  'player.register.activision': 'Activision ID',
  'player.register.password': 'Password',
  'player.register.passwordConfirm': 'Confirm password',
  'player.register.submit': 'Create account',
  'player.register.loading': 'Creating account...',
  'player.register.hasAccount': 'Already have an account? Login',
  'bo.login.title': 'Back-office login',
  'bo.login.email': 'BO email',
  'bo.login.password': 'Password',
  'bo.login.submit': 'Sign in',
  'bo.login.loading': 'Signing in...',
  'bo.login.active': 'BO session active.',
  'bo.login.openUi': 'Open UI6',
  'bo.tournaments.title': 'Back-office - Tournaments',
  'bo.tournaments.subtitle': 'Manual bracket generation for eligible tournaments.',
  'bo.tournaments.createTitle': 'Create tournament (V1)',
  'bo.tournaments.createSubtitle': 'Create a draft, then publish when ready.',
  'bo.tournaments.editTitle': 'Edit draft tournament',
  'bo.tournaments.editSubtitle': 'Only draft tournaments are editable in BO V1.',
  'bo.tournaments.loading': 'Loading tournaments...',
  'bo.tournaments.loadError': 'Unable to load BO tournaments.',
  'bo.tournaments.emptyTitle': 'No tournament available.',
  'bo.tournaments.emptySubtitle': 'Create or publish a tournament from back-office first.',
  'bo.tournaments.noActiveTitle': 'No active tournament in the main view.',
  'bo.tournaments.noActiveSubtitle': 'Archived tournaments stay available in the dedicated section below.',
  'bo.tournaments.status': 'Status: {{value}}',
  'bo.tournaments.lifecycleStatus': 'Public lifecycle: {{value}}',
  'bo.tournaments.registrationClose': 'Registration closes at: {{value}}',
  'bo.tournaments.eligibleTeams': 'Validated teams: {{value}}',
  'bo.tournaments.estimatedRounds': 'Estimated rounds: {{value}}',
  'bo.tournaments.bracketCapacityValue': 'Bracket capacity: {{value}}',
  'bo.tournaments.bracketTypeValue': 'Preferred bracket type: {{value}}',
  'bo.tournaments.bracketStateValue': 'Bracket state: {{value}}',
  'bo.tournaments.archivedAt': 'Archived at: {{value}}',
  'bo.tournaments.finishedAt': 'Marked past at: {{value}}',
  'bo.tournaments.bracketStateNone': 'None',
  'bo.tournaments.bracketStateDraft': 'Draft',
  'bo.tournaments.bracketStatePublished': 'Published',
  'bo.tournaments.lifecycle.upcoming': 'Upcoming',
  'bo.tournaments.lifecycle.ongoing': 'Ongoing',
  'bo.tournaments.lifecycle.past': 'Past',
  'bo.tournaments.alreadyGenerated': 'Bracket already generated.',
  'bo.tournaments.readOnlyRole': 'Read-only: your role cannot generate brackets.',
  'bo.tournaments.notEligible': 'Tournament is not eligible for generation right now.',
  'bo.tournaments.finish': 'Mark as finished',
  'bo.tournaments.reopen': 'Reopen tournament',
  'bo.tournaments.finishing': 'Marking as finished...',
  'bo.tournaments.reopening': 'Reopening...',
  'bo.tournaments.finishSuccess': 'Tournament marked as finished.',
  'bo.tournaments.reopenSuccess': 'Tournament reopened.',
  'bo.tournaments.finishError': 'Unable to mark tournament as finished.',
  'bo.tournaments.reopenError': 'Unable to reopen tournament.',
  'bo.tournaments.archive': 'Archive',
  'bo.tournaments.unarchive': 'Unarchive',
  'bo.tournaments.archiving': 'Archiving...',
  'bo.tournaments.unarchiving': 'Unarchiving...',
  'bo.tournaments.archiveSuccess': 'Tournament archived successfully.',
  'bo.tournaments.unarchiveSuccess': 'Tournament restored successfully.',
  'bo.tournaments.archiveError': 'Unable to archive tournament.',
  'bo.tournaments.unarchiveError': 'Unable to unarchive tournament.',
  'bo.tournaments.archivedTitle': 'Archived tournaments ({{count}})',
  'bo.tournaments.archivedSubtitle': 'Archived tournaments stay available without cluttering the main BO view.',
  'bo.tournaments.showArchived': 'Show archived',
  'bo.tournaments.hideArchived': 'Hide archived',
  'bo.tournaments.editDraft': 'Edit draft',
  'bo.tournaments.openSetup': 'Setup generation',
  'bo.tournaments.manageDraftBracket': 'Manage draft bracket',
  'bo.tournaments.setupTitle': 'Bracket generation (V1)',
  'bo.tournaments.setupTitleDraft': 'Draft bracket (V1)',
  'bo.tournaments.bracketType': 'Bracket type',
  'bo.tournaments.drawMode': 'Draw mode',
  'bo.tournaments.singleElimination': 'Single elimination',
  'bo.tournaments.doubleElimination': 'Double elimination',
  'bo.tournaments.drawModeRandom': 'Random',
  'bo.tournaments.drawModeSeeded': 'Seeded',
  'bo.tournaments.drawModeManual': 'Manual',
  'bo.tournaments.drawModeWheel': 'Wheel',
  'bo.tournaments.rulePublished': 'Tournament is published',
  'bo.tournaments.ruleRegistrationClosed': 'Registration closed',
  'bo.tournaments.ruleMinimumTeams': 'At least 2 validated teams',
  'bo.tournaments.ruleCapacityCompatible': 'Validated team count stays within the target bracket capacity',
  'bo.tournaments.ruleNoPublishedBracket': 'No published bracket blocks this tournament',
  'bo.tournaments.ruleSeedingReady': 'Validated teams have unique consecutive seeds from 1 to N',
  'bo.tournaments.ruleManualReady': 'Every validated team has a unique manual slot between 1 and the target capacity',
  'bo.tournaments.ruleWheelReady': 'Validated teams have unique consecutive wheel orders from 1 to N',
  'bo.tournaments.ruleDraftMatchesCurrentTeams': 'Draft still matches the current draw (teams + seeds, wheel order or manual slots)',
  'bo.tournaments.generateDraft': 'Generate draft bracket',
  'bo.tournaments.regenerateDraft': 'Regenerate draft bracket',
  'bo.tournaments.publishBracket': 'Publish bracket',
  'bo.tournaments.publishingBracket': 'Publishing bracket...',
  'bo.tournaments.generating': 'Generating...',
  'bo.tournaments.cancelSetup': 'Cancel',
  'bo.tournaments.success': 'Draft bracket updated successfully.',
  'bo.tournaments.publishBracketSuccess': 'Bracket published successfully.',
  'bo.tournaments.generateError': 'Generation failed.',
  'bo.tournaments.publishBracketError': 'Bracket publication failed.',
  'bo.tournaments.publishBracketNotReady': 'Draft bracket is not publishable yet.',
  'bo.tournaments.publishBlockedRegistrationOpen': 'Bracket publication waits until registration closes.',
  'bo.tournaments.publishBlockedDraftChanged': 'The draft no longer matches the current draw (teams or seeds). Regenerate before publishing.',
  'bo.tournaments.publishBlockedSeedsChanged': 'The current seeds no longer match this draft. Regenerate before publishing.',
  'bo.tournaments.publishBlockedManualChanged': 'The current manual slots no longer match this draft. Regenerate before publishing.',
  'bo.tournaments.publishBlockedWheelChanged': 'The current wheel order no longer matches this draft. Regenerate before publishing.',
  'bo.tournaments.publishBlockedMinimumTeams': 'At least 2 validated teams are required before publishing the bracket.',
  'bo.tournaments.publishBlockedCapacityExceeded': 'Validated team count exceeds the target bracket capacity.',
  'bo.tournaments.noDraftBracket': 'No draft bracket is available.',
  'bo.tournaments.viewRegistrations': 'View registrations',
  'bo.tournaments.previewBracket': 'Preview BO bracket',
  'bo.tournaments.saveDraft': 'Save draft',
  'bo.tournaments.publishNow': 'Publish now',
  'bo.tournaments.saving': 'Saving...',
  'bo.tournaments.publishing': 'Publishing...',
  'bo.tournaments.cancelEdit': 'Cancel edit',
  'bo.tournaments.draftCreatedSuccess': 'Draft tournament created.',
  'bo.tournaments.draftUpdatedSuccess': 'Draft tournament updated.',
  'bo.tournaments.publishedSuccess': 'Tournament published successfully.',
  'bo.tournaments.saveError': 'Unable to save tournament.',
  'bo.tournaments.publishError': 'Unable to publish tournament.',
  'bo.tournaments.form.name': 'Name',
  'bo.tournaments.form.slug': 'Slug',
  'bo.tournaments.form.game': 'Game',
  'bo.tournaments.form.tournamentType': 'Tournament type',
  'bo.tournaments.form.teamTournament': 'Team',
  'bo.tournaments.form.individualTournament': 'Individual',
  'bo.tournaments.form.formatLabel': 'Format label',
  'bo.tournaments.form.region': 'Region',
  'bo.tournaments.form.startsAt': 'Starts at',
  'bo.tournaments.form.registrationClosesAt': 'Registration closes at',
  'bo.tournaments.form.checkInOpensAt': 'Check-in opens at',
  'bo.tournaments.form.checkInClosesAt': 'Check-in closes at',
  'bo.tournaments.form.bracketCapacity': 'Bracket capacity',
  'bo.tournaments.form.bracketType': 'Bracket type',
  'bo.tournaments.form.crossplay': 'Crossplay enabled',
  'bo.tournaments.form.description': 'Description',
  'bo.tournaments.form.rules': 'Rules',
  'bo.tournaments.form.prizePool': 'Prize pool',
  'bo.tournaments.form.bannerUrl': 'Banner URL',
  'bo.tournaments.toReports': 'Go to BO score reports',
  'bo.registrations.title': 'Back-office - Tournament registrations',
  'bo.registrations.back': '<- Back to BO tournaments',
  'bo.registrations.tournament': 'Tournament',
  'bo.registrations.selectTournament': 'Select a tournament',
  'bo.registrations.load': 'Load',
  'bo.registrations.session': 'Back-office session',
  'bo.registrations.tournamentsLoading': 'Loading tournaments...',
  'bo.registrations.loading': 'Loading registrations...',
  'bo.registrations.emptyTitle': 'No registrations for this tournament.',
  'bo.registrations.emptySubtitle': 'Validated teams will appear here for BO processing.',
  'bo.registrations.forbiddenTournaments': 'Your role cannot read the BO tournament list.',
  'bo.registrations.loadTournamentsError': 'Unable to load BO tournaments.',
  'bo.registrations.forbiddenList': 'Your role cannot read these registrations.',
  'bo.registrations.loadError': 'Unable to load registrations.',
  'bo.registrations.submittedAt': 'Submitted at: {{value}}',
  'bo.registrations.checkedInAt': 'Checked in at: {{value}}',
  'bo.registrations.latestDecision': 'Latest decision: {{value}} ({{date}})',
  'bo.registrations.seed': 'BO seed',
  'bo.registrations.wheelTitle': 'BO wheel',
  'bo.registrations.wheelSubtitle': 'Generates a persisted order for validated teams, reusable by the wheel draw mode.',
  'bo.registrations.wheelRun': 'Run wheel',
  'bo.registrations.wheelRunning': 'Running wheel...',
  'bo.registrations.wheelOrderValue': 'BO wheel order: {{value}}',
  'bo.registrations.seedSave': 'Save seed',
  'bo.registrations.seedSaving': 'Saving seed...',
  'bo.registrations.saved': 'Saved',
  'bo.registrations.manualSlot': 'BO manual slot',
  'bo.registrations.manualSlotSave': 'Save slot',
  'bo.registrations.manualSlotSaving': 'Saving slot...',
  'bo.registrations.reason': 'BO reason (optional)',
  'bo.registrations.saving': 'Saving...',
  'bo.registrations.decisionError': 'Unable to apply the decision.',
  'bo.registrations.seedError': 'Unable to save the seed.',
  'bo.registrations.wheelError': 'Unable to run the wheel.',
  'bo.registrations.manualSlotError': 'Unable to save the manual slot.',
  'bo.registrations.checkIn': 'BO check-in',
  'bo.registrations.checkInLoading': 'Checking in...',
  'bo.registrations.checkInError': 'Unable to check in this registration.',
  'bo.registrations.status.submitted': 'Submitted',
  'bo.registrations.status.toFix': 'Changes requested',
  'bo.registrations.status.validated': 'Validated',
  'bo.registrations.status.validatedConditionally': 'Conditionally approved',
  'bo.registrations.status.rejected': 'Rejected',
  'bo.registrations.status.cancelled': 'Cancelled',
  'bo.registrations.action.toFix': 'Request changes',
  'bo.registrations.action.validate': 'Validate',
  'bo.registrations.action.validateConditionally': 'Approve with conditions',
  'bo.registrations.action.reject': 'Reject',
  'bo.registrations.action.cancel': 'Cancel',
  'bo.registrations.checkIn.checkedIn': 'Team already checked in.',
  'bo.registrations.checkIn.eligible': 'Team is eligible for BO check-in.',
  'bo.registrations.checkIn.closed': 'Check-in window is closed.',
  'bo.registrations.checkIn.notEligible': 'Team is not eligible for check-in.',
  'public.list.title': 'Public tournaments',
  'public.list.subtitle': 'Grouped into blocks for clearer reading.',
  'public.list.visibleCount': '{{count}} visible tournament(s)',
  'public.list.loading': 'Loading...',
  'public.list.error': 'Unable to load tournaments.',
  'public.list.empty': 'No published tournaments yet.',
  'public.list.activeBlock': 'Upcoming / ongoing',
  'public.list.activeHint': 'Classification driven by backend public lifecycle status.',
  'public.list.activeEmpty': 'No upcoming or ongoing tournaments.',
  'public.list.pastBlock': 'Past tournaments',
  'public.list.pastHint': 'Tournaments marked as finished by backend source of truth.',
  'public.list.pastEmpty': 'No past tournaments yet.',
  'public.list.inProgress': 'Live',
  'public.list.region': 'Region: {{value}}',
  'public.list.start': 'Start: {{value}}',
  'public.list.viewDetail': 'View tournament details',
  'public.detail.back': '<- Back to list',
  'public.detail.region': 'Region: {{value}}',
  'public.detail.crossplay.on': 'Crossplay enabled',
  'public.detail.crossplay.off': 'No crossplay',
  'public.detail.viewBracket': 'View bracket',
  'public.detail.registerTeam': 'Register a team',
  'public.detail.loginNeeded': 'Log in with a player account to register a team.',
  'public.detail.goLogin': 'Sign in to register',
  'public.detail.start': 'Start:',
  'public.detail.registrationClose': 'Registration closes:',
  'public.detail.prize': 'Prize pool:',
  'public.detail.description': 'Description',
  'public.detail.rules': 'Rules',
  'public.detail.loading': 'Loading...',
  'public.detail.error': 'Unable to load this tournament.',
  'public.bracket.back': '<- Back to tournament',
  'public.bracket.backToMatches': '<- Back to My matches',
  'public.bracket.titleSuffix': 'Bracket',
  'public.bracket.readOnly': 'Read-only: official results are validated from back-office.',
  'bo.bracketPreview.back': '<- Back to BO tournaments',
  'bo.bracketPreview.eyebrow': 'BO bracket',
  'bo.bracketPreview.draftLegend': 'BO-only preview: this draft bracket is not public yet.',
  'bo.bracketPreview.publishedLegend': 'BO preview: this bracket is already published and visible publicly.',
  'bo.bracketPreview.loading': 'Loading BO bracket...',
  'bo.bracketPreview.error': 'BO bracket unavailable for this tournament.',
  'public.bracket.loading': 'Loading bracket...',
  'public.bracket.error': 'Bracket unavailable for this tournament.',
  'public.bracket.match': 'Match {{value}}',
  'public.bracket.tbd': 'TBD',
  'public.bracket.winner': 'Winner:',
  'public.bracket.reportScore': 'Report score',
  'public.bracket.contestReport': 'Contest report',
  'public.bracket.kind.simple': 'Single elimination',
  'player.profile.title': 'My player profile',
  'player.profile.subtitle': 'Private space: your account information and in-game identity.',
  'player.profile.loading': 'Loading...',
  'player.profile.emailReadonly': 'Email (read-only)',
  'player.profile.pseudo': 'Nickname',
  'player.profile.activision': 'Activision ID',
  'player.profile.avatar': 'Avatar URL (optional)',
  'player.profile.country': '2-letter ISO country (optional)',
  'player.profile.save': 'Save changes',
  'player.profile.saving': 'Saving...',
  'player.profile.updated': 'Profile updated.',
  'player.profile.loadError': 'Unable to load profile.',
  'player.profile.updateError': 'Update failed.',
  'player.matches.title': 'My matches to report',
  'player.matches.subtitle': 'Minimal action inbox: only matches you can report right now.',
  'player.matches.openTournaments': 'Open tournaments',
  'player.matches.loading': 'Loading your reportable matches...',
  'player.matches.emptyTitle': 'No match to report right now.',
  'player.matches.emptySubtitle': 'Come back later or open public brackets to follow your matches.',
  'player.matches.emptyCta': 'View tournaments',
  'player.matches.loadError': 'Unable to load your reportable matches.',
  'player.matches.matchNumber': 'Match {{value}}',
  'player.matches.startsAt': 'Tournament start: {{value}}',
  'player.matches.viewBracket': 'View bracket',
  'player.matches.reportScore': 'Report score',
  'player.matches.status.ready': 'Ready to report',
  'player.matches.status.reported': 'Reported',
  'player.matches.status.inReview': 'In BO review',
  'player.matches.status.rejected': 'Needs update',
  'player.teams.title': 'My teams',
  'player.teams.create': 'Create a team',
  'player.teams.loading': 'Loading your teams...',
  'player.teams.none.title': 'You do not have any team yet.',
  'player.teams.none.subtitle': 'Create your team or accept an invitation link you received.',
  'player.teams.myRole': 'My role: {{value}}',
  'player.teams.logo': 'Logo: {{value}}',
  'player.teams.viewRoster': 'View roster',
  'player.teams.openTournaments': 'View tournaments',
  'player.teams.manageable': 'Manageable team for tournament registration',
  'player.teams.notManageable': 'Not manageable (regular member)',
  'player.teams.loadError': 'Unable to load your teams. Please retry.',
  'player.teamCreate.title': 'Create a team',
  'player.teamCreate.subtitle': 'On creation, you become captain of this team.',
  'player.teamCreate.name': 'Team name',
  'player.teamCreate.logo': 'Logo URL (optional)',
  'player.teamCreate.submit': 'Create team',
  'player.teamCreate.loading': 'Creating team...',
  'player.teamCreate.links': 'View my teams · View my invitations',
  'player.teamCreate.viewTeams': 'View my teams',
  'player.teamCreate.viewInvitations': 'View my invitations',
  'player.teamCreate.error': 'Unable to create team. Check fields and retry.',
  'player.teamDetail.back': '<- Back to my teams',
  'player.teamDetail.loading': 'Loading team...',
  'player.teamDetail.myRole': 'My role:',
  'player.teamDetail.logo': 'Logo: {{value}}',
  'player.teamDetail.inviteTitle': 'Invite by link',
  'player.teamDetail.inviteSubtitle': 'Generate or regenerate a shareable link to invite a player into the team.',
  'player.teamDetail.inviteGenerate': 'Generate invite link',
  'player.teamDetail.inviteRegenerate': 'Regenerate link',
  'player.teamDetail.generating': 'Generating...',
  'player.teamDetail.inviteReady': 'Link ready. You can now share it.',
  'player.teamDetail.inviteError': 'Unable to generate invitation link.',
  'player.teamDetail.rosterTitle': 'Roster',
  'player.teamDetail.tournamentHubTitle': 'Tournament journey',
  'player.teamDetail.tournamentHubManageable': 'You can register this team to an open tournament.',
  'player.teamDetail.tournamentHubNotManageable': 'You can browse tournaments, but registration is restricted to captain/team manager.',
  'player.teamDetail.tournamentHubCta': 'Browse tournaments',
  'player.teamDetail.remove': 'Remove',
  'player.teamDetail.removing': 'Removing...',
  'player.teamDetail.removed': 'Member removed from team.',
  'player.teamDetail.removeError': 'Removal failed.',
  'player.teamDetail.role.captain': 'Captain',
  'player.teamDetail.role.manager': 'Team manager',
  'player.teamDetail.role.player': 'Player',
  'player.teamDetail.forbidden': 'Access denied: you must be a member of this team.',
  'player.teamDetail.loadError': 'Unable to load this team.',
  'player.invitations.title': 'My team invitations',
  'player.invitations.loading': 'Loading invitations...',
  'player.invitations.none.title': 'No pending invitation.',
  'player.invitations.none.subtitle': 'You can view your teams, create one, or return to public tournaments.',
  'player.invitations.from': 'Invited by: {{value}}',
  'player.invitations.role': 'Suggested role: {{value}}',
  'player.invitations.date': 'Date: {{value}}',
  'player.invitations.accept': 'Accept invitation',
  'player.invitations.accepting': 'Accepting...',
  'player.invitations.acceptError': 'Unable to accept invitation right now.',
  'player.invitations.loadError': 'Unable to load invitations. Please retry.',
  'teamInvite.title': 'Team invitation',
  'teamInvite.loading': 'Loading invitation link...',
  'teamInvite.role': 'Suggested role: {{value}}',
  'teamInvite.expires': 'Expires on: {{value}}',
  'teamInvite.authRequired': 'Log in or create your account to accept this invitation.',
  'teamInvite.playerLogin': 'Player login',
  'teamInvite.playerRegister': 'Player registration',
  'teamInvite.accept': 'Join this team',
  'teamInvite.accepting': 'Accepting...',
  'teamInvite.accepted': 'Invitation accepted. Redirecting to your team...',
  'teamInvite.invalid': 'Invalid invitation link.',
  'teamInvite.loadError': 'Unable to load this invitation link.',
  'teamInvite.error': 'Unable to accept this link right now.',
  'teamInvite.reason.expired': 'This invitation link has expired.',
  'teamInvite.reason.alreadyMember': 'You are already a member of this team.',
  'teamInvite.reason.consumed': 'This invitation has already been consumed.',
  'teamInvite.reason.full': 'This team is full (max 6 players).',
  'teamInvite.reason.playerRequired': 'Only an active player account can accept this invitation.',
  'teamInvite.reason.unavailable': 'This invitation is no longer available.',
  'reg.back': '<- Back to tournament',
  'reg.title': 'Tournament registration (team)',
  'reg.subtitle': 'Only your manageable teams (captain/team manager) can be registered.',
  'reg.pageLoading': 'Loading tournament...',
  'reg.start': 'Start: {{value}}',
  'reg.close': 'Registration closes: {{value}}',
  'reg.actionTitle': 'Registration action',
  'reg.actionStateTitle': 'Current state',
  'reg.actionState.closed': 'Registrations closed',
  'reg.actionState.already': 'Registration already active',
  'reg.actionState.noTeam': 'No manageable team',
  'reg.actionState.ready': 'Registration available',
  'reg.actionReasonTitle': 'Reason',
  'reg.nextStepTitle': 'Next step',
  'reg.nextStep.closed': 'View tournament bracket or results.',
  'reg.nextStep.already': 'Check your registration status below then perform check-in when eligible.',
  'reg.nextStep.noTeam': 'Create a team or get captain/team-manager role.',
  'reg.nextStep.ready': 'Select a team then submit registration.',
  'reg.closed': 'Registrations are closed for this tournament.',
  'reg.already': 'A registration already exists for {{team}} (status: {{status}}).',
  'reg.noNeed': 'No new registration is needed right now.',
  'reg.teamsLoading': 'Loading teams...',
  'reg.noManageable': 'You do not have a manageable team to register a roster yet.',
  'reg.nextAction': 'Next action:',
  'reg.createTeamLink': 'create a team',
  'reg.teamLabel': 'Team',
  'reg.teamSelect': '-- Select a team --',
  'reg.submit': 'Register team',
  'reg.submitting': 'Registering...',
  'reg.listTitle': 'My registrations for this tournament',
  'reg.listLoading': 'Loading registrations...',
  'reg.listEmpty': 'No registration for this tournament.',
  'reg.status': 'status: {{value}}',
  'reg.submittedAt': 'Submitted on: {{value}}',
  'reg.cancelledAt': 'Cancelled on: {{value}}',
  'reg.checkIn.ok': 'Check-in confirmed for this team.',
  'reg.checkIn.eligible': 'Team is eligible for check-in.',
  'reg.checkIn.closed': 'Check-in unavailable: window closed.',
  'reg.checkIn.notEligible': 'Check-in not eligible (current status: {{value}}).',
  'reg.checkIn.do': 'Perform check-in',
  'reg.checkIn.loading': 'Checking in...',
  'reg.cancel': 'Cancel registration',
  'reg.cancel.loading': 'Cancelling...',
  'reg.loadError': 'Unable to load this tournament.',
  'reg.selectTeam': 'Please select a team.',
  'reg.successRegistered': 'Registration recorded for {{team}} ({{status}}).',
  'reg.error': 'Registration failed.',
  'reg.successCancelled': 'Registration cancelled for {{team}}.',
  'reg.cancelError': 'Cancellation failed.',
  'reg.successCheckIn': 'Check-in confirmed for {{team}}.',
  'reg.checkInError': 'Check-in failed.',
  'reg.listError': 'Unable to load your registrations for this tournament.',
  'reg.quickLinks': 'Quick links',
  'reg.quick.toTeams': 'My teams',
  'reg.quick.toBracket': 'Tournament bracket',
  'reg.quick.toTournament': 'Tournament details',
  'reg.status.submitted': 'submitted',
  'reg.status.to_fix': 'to fix',
  'reg.status.validated': 'validated',
  'reg.status.validated_conditionally': 'validated conditionally',
  'reg.status.rejected': 'rejected',
  'reg.status.cancelled': 'cancelled',
  'score.back': '<- Back to bracket',
  'score.backToMatches': '<- Back to My matches',
  'score.title': 'Player score report',
  'score.hint': 'Tournament: {{slug}} - Match: {{id}}',
  'score.hint2': 'Reporting team is auto-suggested from your teams present in this match.',
  'score.loading': 'Loading score report...',
  'score.status': 'Status:',
  'score.editable': 'Editable:',
  'score.yes': 'Yes',
  'score.no': 'No',
  'score.reportingTeam': 'Reporting team:',
  'score.global': 'Global score:',
  'score.updated': 'Updated:',
  'score.none': 'No score report for this match.',
  'score.form.edit': 'Edit report',
  'score.form.new': 'New report',
  'score.form.team': 'Reporting team',
  'score.form.selectTeam': '-- Select team --',
  'score.form.noTeam': 'No eligible team found for this match.',
  'score.form.team1': 'Team 1 score',
  'score.form.team2': 'Team 2 score',
  'score.form.teamNamed': '{{team}} score',
  'score.form.note': 'Note (optional)',
  'score.games.title': 'Maps/games details (optional)',
  'score.games.add': 'Add map/game',
  'score.games.num': 'Game #',
  'score.games.map': 'Map',
  'score.games.t1': 'T1',
  'score.games.t2': 'T2',
  'score.shots.title': 'Proof screenshot',
  'score.shots.add': 'Add screenshot URL',
  'score.shots.file': 'Proof screenshot',
  'score.shots.help': '1 image max. Accepted: PNG, JPG/JPEG, WEBP. Max 5 MB.',
  'score.shots.none': 'No proof screenshot attached.',
  'score.shots.current': 'Current proof',
  'score.shots.selected': 'Selected proof',
  'score.shots.invalidType': 'Only PNG, JPG/JPEG, or WEBP images are allowed.',
  'score.shots.tooLarge': 'Image must be 5 MB or smaller.',
  'score.shots.previewAlt': 'Score proof screenshot preview',
  'score.shots.position': 'Position',
  'score.shots.url': 'Screenshot URL',
  'score.shots.caption': 'Caption',
  'score.remove': 'Remove',
  'score.submit': 'Submit score report',
  'score.submitting': 'Submitting...',
  'score.locked': 'Report is not editable from player area (final status).',
  'score.selectTeamError': 'Please select a reporting team.',
  'score.saved': 'Score report saved.',
  'score.saveError': 'Save failed.',
  'score.contest.title': 'Contest this report',
  'score.contest.edit': 'Update contest',
  'score.contest.help': 'Use this form if the opposing team reported a score that you dispute.',
  'score.contest.team': 'Contesting team',
  'score.contest.note': 'Contest message',
  'score.contest.submit': 'Submit contest',
  'score.contest.update': 'Update contest',
  'score.contest.submitting': 'Submitting...',
  'score.contest.saved': 'Contest saved.',
  'score.contest.saveError': 'Unable to save contest.',
  'score.contest.error': 'Please select a team and add a contest message.',
  'score.contest.locked': 'This report can no longer be contested.',
  'score.contest.ownTeam': 'The reporting team cannot contest its own report.',
  'score.contest.banner': 'Report contested',
  'score.contest.teamBanner': 'Contesting team: {{team}}',
  'score.contest.noteBanner': 'Message: {{value}}',
  'score.loadError': 'Unable to load score report.',
  'score.status.reported': 'Reported (pending BO)',
  'score.status.review': 'In review (BO review)',
  'score.status.validated': 'Validated (official)',
  'score.status.rejected': 'Rejected (to fix)',
  'bo.reports.title': 'Back-office - Score reports',
  'bo.reports.tournament': 'Tournament',
  'bo.reports.selectTournament': '-- Select tournament --',
  'bo.reports.load': 'Load',
  'bo.reports.session': 'Back-office session',
  'bo.reports.tournamentsLoading': 'Loading tournaments...',
  'bo.reports.loading': 'Loading reports...',
  'bo.reports.emptyTitle': 'No score report for this tournament.',
  'bo.reports.emptySubtitle': 'Check that at least one match was reported by a team.',
  'bo.reports.report': 'Report #{{id}}',
  'bo.reports.match': 'Match: {{match}} | Team: {{team}}',
  'bo.reports.score': 'Score: {{s1}} - {{s2}} | Date: {{date}}',
  'bo.reports.detail': 'View details',
  'bo.reports.loadTournamentsError': 'Unable to load BO tournament list.',
  'bo.reports.loadError': 'Unable to load BO score reports.',
  'bo.reports.forbiddenList': 'Access denied: you can view reports but cannot process this tournament.',
  'bo.reports.forbiddenTournaments': 'Access denied: your back-office role does not allow this consultation.',
  'bo.reports.status.reported': 'Reported',
  'bo.reports.status.review': 'In review',
  'bo.reports.status.validated': 'Validated',
  'bo.reports.status.rejected': 'Rejected',
  'bo.reports.contested': 'Contested',
  'bo.reportDetail.back': '<- Back to list',
  'bo.reportDetail.title': 'BO - Score report details',
  'bo.reportDetail.loading': 'Loading...',
  'bo.reportDetail.report': 'Report #{{id}}',
  'bo.reportDetail.status': 'status: {{value}}',
  'bo.reportDetail.match': 'Match: {{id}} (R{{round}} M{{match}})',
  'bo.reportDetail.team': 'Reporting team: {{team}} | User: {{user}}',
  'bo.reportDetail.global': 'Global score: {{s1}} - {{s2}}',
  'bo.reportDetail.date': 'Reported on: {{date}}',
  'bo.reportDetail.note': 'Note: {{value}}',
  'bo.reportDetail.games': 'Maps/games details',
  'bo.reportDetail.noGames': 'No maps/games details.',
  'bo.reportDetail.gameRow': 'Game {{num}} - {{map}} - {{s1}}:{{s2}}',
  'bo.reportDetail.screens': 'Screenshots URL',
  'bo.reportDetail.noScreens': 'No screenshot.',
  'bo.reportDetail.openPreview': 'Open preview',
  'bo.reportDetail.previewTitle': 'Screenshot preview',
  'bo.reportDetail.closePreview': 'Close',
  'bo.reportDetail.contestTitle': 'Opponent contest',
  'bo.reportDetail.contestTeam': 'Contesting team: {{team}}',
  'bo.reportDetail.contestUser': 'Player: {{user}}',
  'bo.reportDetail.contestDate': 'Contested on: {{date}}',
  'bo.reportDetail.contestNote': 'Message: {{value}}',
  'bo.reportDetail.decision': 'Admin decision',
  'bo.reportDetail.newStatus': 'New status',
  'bo.reportDetail.optNote': 'Note (optional)',
  'bo.reportDetail.apply': 'Apply decision',
  'bo.reportDetail.applied': 'Decision applied: {{value}}',
  'bo.reportDetail.history': 'Decision history',
  'bo.reportDetail.noHistory': 'No decision recorded.',
  'bo.reportDetail.historyRow': '{{from}} -> {{to}} | actor {{actor}} | {{date}}',
  'bo.reportDetail.historyNote': ' | note: {{value}}',
  'bo.reportDetail.forbiddenOpen': 'Access denied: your role cannot open this score report.',
  'bo.reportDetail.loadError': 'Unable to load details.',
  'bo.reportDetail.forbiddenApply': 'Access denied: you are not allowed to apply this decision.',
  'bo.reportDetail.decisionError': 'Decision failed.',
  'information.title': 'Information',
  'information.subtitle': 'Public presentation of the ECL Vault league.',
  'information.vision': 'Our vision',
  'information.visionText': 'ECL Vault provides an esports competition platform focused on tournament readability, result integrity, and community experience.',
  'information.structured': 'Structured tournaments',
  'information.structuredText': 'Public calendar, readable brackets, and transparent round progression.',
  'information.verified': 'Verified results',
  'information.verifiedText': 'Team report, back-office review, and official validation before propagation.',
  'information.playerExp': 'Player experience',
  'information.playerExpText': 'Accounts, teams, registration, check-in, and match tracking in a single flow.',
  'information.note': 'Product note',
  'information.noteText': 'This page is a credible public placeholder pending final editorial content validated by product team.',
  'hof.title': 'Hall of Fame',
  'hof.subtitle': 'Temporary visual rankings pending official automated data.',
  'hof.mock': 'Mock',
  'hof.feed': 'Public feed',
  'hof.topTeams': 'Top Teams',
  'hof.topPlayers': 'Top Players',
  'hof.recentWinners': 'Recent Winners',
  'hof.col.rank': '#',
  'hof.col.team': 'Team',
  'hof.col.points': 'Points',
  'hof.col.titles': 'Titles',
  'hof.col.player': 'Player',
  'hof.col.rating': 'Rating',
  'hof.note': 'Temporary Hall of Fame data: target visual structure without backend ranking logic yet.'
};

const TRANSLATIONS: Record<AppLang, TranslationMap> = { fr: FR, en: EN };

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly language = signal<AppLang>(this.readStoredLanguage());
  readonly currentLanguage = this.language.asReadonly();

  setLanguage(lang: AppLang): void {
    localStorage.setItem(LANG_KEY, lang);
    this.language.set(lang);
  }

  t(key: string, params?: Record<string, string | number | null | undefined>): string {
    const lang = this.language();
    const template = TRANSLATIONS[lang][key] ?? TRANSLATIONS.fr[key] ?? key;
    if (!params) {
      return template;
    }

    return template.replace(/\{\{(\w+)\}\}/g, (_full, token: string) => {
      const value = params[token];
      return value == null ? '' : String(value);
    });
  }

  isLanguage(lang: AppLang): boolean {
    return this.language() === lang;
  }

  private readStoredLanguage(): AppLang {
    const raw = localStorage.getItem(LANG_KEY);
    return raw === 'en' ? 'en' : 'fr';
  }
}
